import { useState, useCallback } from 'react';

/**
 * Custom hook for managing sliding panel state
 * Simple open/close state management for panel components
 */
const useSlidingPanel = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  /**
   * Open the panel
   */
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  /**
   * Close the panel
   */
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  /**
   * Toggle the panel open/closed
   */
  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    open,
    close,
    toggle,
    setIsOpen,
  };
};

export default useSlidingPanel;
